// project import
import dashboard from './dashboard';
import utilities from './utilities';
import manuf from './manuf';
import FactoryConfiguration from './factoryconfiguration';
import FactoryOperations from './factoryoperations';
import FactoryAmin from './factoryamin';
import Insight from './insight';
import DigitalMarketing from './digitalmarketing';
import WorkForceMgmt from './workforcemgmt';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [FactoryConfiguration,FactoryOperations,FactoryAmin,Insight,DigitalMarketing,WorkForceMgmt,dashboard, manuf, utilities]
};

export default menuItems;